import React from "react";

export const System = () => {
  return (
    <svg
      width="642"
      height="254"
      viewBox="0 0 642 254"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="min-w-[370px] w-[95%] md:w-[560px] md:h-[240px]"
    >
      <g clipPath="url(#clip0_905_5903)">
        <rect width="642" height="254" rx="13" fill="white" />
        <mask
          id="mask0_905_5903"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="-9"
          y="44"
          width="659"
          height="210"
        >
          <rect
            x="-9"
            y="44"
            width="659"
            height="210"
            fill="url(#paint0_radial_905_5903)"
          />
        </mask>
        <g mask="url(#mask0_905_5903)">
          <circle opacity="0.75" cx="9" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.47" cx="25" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.75" cx="41" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.99" cx="57" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.23" cx="73" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.26" cx="89" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.82" cx="105" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.68" cx="121" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.46" cx="137" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.42" cx="153" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.67" cx="169" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.95" cx="185" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.22" cx="201" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.71" cx="217" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.57" cx="233" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.57" cx="249" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.59" cx="265" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.49" cx="281" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.37" cx="297" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.29" cx="313" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.35" cx="329" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.62" cx="345" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.91" cx="361" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.53" cx="377" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.99" cx="393" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.86" cx="409" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.69" cx="425" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.79" cx="441" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.16" cx="457" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.33" cx="473" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.44" cx="489" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.74" cx="505" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.46" cx="521" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.89" cx="537" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.13" cx="553" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.12" cx="569" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.51" cx="585" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.6" cx="601" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.61" cx="617" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.51" cx="633" cy="56" r="4" fill="#B6F4FC" />
          <circle opacity="0.63" cx="9" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.6" cx="25" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.59" cx="41" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.65" cx="57" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.71" cx="73" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.15" cx="89" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.84" cx="105" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.4" cx="121" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.9" cx="137" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.95" cx="153" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.33" cx="169" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.64" cx="185" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.82" cx="201" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.96" cx="217" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.56" cx="233" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.23" cx="249" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.46" cx="265" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.48" cx="281" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.7" cx="297" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.76" cx="313" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.7" cx="329" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.33" cx="345" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.72" cx="361" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.37" cx="377" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.99" cx="393" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.38" cx="409" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.79" cx="425" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.81" cx="441" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.98" cx="457" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.68" cx="473" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.99" cx="489" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.76" cx="505" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.45" cx="521" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.18" cx="537" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.97" cx="553" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.72" cx="569" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.61" cx="585" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.89" cx="601" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.5" cx="617" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.32" cx="633" cy="72" r="4" fill="#B6F4FC" />
          <circle opacity="0.43" cx="9" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.33" cx="25" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.53" cx="41" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.54" cx="57" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.52" cx="73" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.24" cx="89" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.35" cx="105" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.37" cx="121" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.11" cx="137" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.73" cx="153" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.15" cx="169" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.94" cx="185" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.67" cx="201" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.27" cx="217" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.46" cx="233" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.2" cx="249" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.71" cx="265" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.83" cx="281" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.75" cx="297" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.26" cx="313" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.25" cx="329" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.89" cx="345" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.67" cx="361" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.36" cx="377" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.6" cx="393" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.5" cx="409" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.75" cx="425" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.29" cx="441" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.67" cx="457" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.35" cx="473" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.92" cx="489" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.87" cx="505" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.28" cx="521" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.61" cx="537" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.56" cx="553" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.18" cx="569" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.79" cx="585" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.18" cx="601" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.15" cx="617" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.86" cx="633" cy="88" r="4" fill="#B6F4FC" />
          <circle opacity="0.27" cx="9" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.37" cx="25" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.93" cx="41" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.58" cx="57" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.2" cx="73" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.11" cx="89" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.65" cx="105" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.45" cx="121" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.42" cx="137" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.59" cx="153" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.42" cx="169" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.47" cx="185" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.2" cx="201" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.26" cx="217" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.52" cx="233" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.57" cx="249" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.66" cx="265" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.65" cx="281" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.2" cx="297" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.65" cx="313" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.87" cx="329" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.76" cx="345" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.61" cx="361" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.72" cx="377" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.89" cx="393" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.18" cx="409" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.59" cx="425" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.66" cx="441" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.62" cx="457" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.24" cx="473" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.11" cx="489" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.38" cx="505" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.32" cx="521" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.58" cx="537" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.72" cx="553" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.35" cx="569" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.47" cx="585" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.78" cx="601" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.19" cx="617" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.84" cx="633" cy="104" r="4" fill="#B6F4FC" />
          <circle opacity="0.86" cx="9" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.36" cx="25" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.5" cx="41" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.79" cx="57" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.91" cx="73" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.39" cx="89" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.79" cx="105" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.32" cx="121" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.63" cx="137" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.62" cx="153" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.8" cx="169" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.5" cx="185" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.85" cx="201" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.8" cx="217" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.86" cx="233" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.17" cx="249" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.75" cx="265" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.16" cx="281" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.99" cx="297" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.72" cx="313" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.47" cx="329" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.44" cx="345" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.12" cx="361" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.94" cx="377" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.27" cx="393" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.37" cx="409" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.91" cx="425" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.52" cx="441" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.36" cx="457" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.72" cx="473" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.96" cx="489" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.75" cx="505" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.57" cx="521" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.67" cx="537" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.47" cx="553" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.34" cx="569" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.56" cx="585" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.16" cx="601" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.93" cx="617" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.89" cx="633" cy="120" r="4" fill="#B6F4FC" />
          <circle opacity="0.18" cx="9" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.22" cx="25" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.83" cx="41" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.37" cx="57" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.64" cx="73" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.59" cx="89" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.76" cx="105" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.99" cx="121" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.9" cx="137" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.94" cx="153" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.54" cx="169" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.3" cx="185" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.7" cx="201" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.75" cx="217" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.2" cx="233" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.84" cx="249" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.31" cx="265" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.85" cx="281" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.4" cx="297" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.36" cx="313" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.31" cx="329" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.78" cx="345" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.52" cx="361" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.75" cx="377" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.83" cx="393" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.68" cx="409" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.95" cx="425" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.14" cx="441" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.86" cx="457" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.24" cx="473" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.76" cx="489" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.94" cx="505" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.44" cx="521" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.18" cx="537" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.91" cx="553" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.89" cx="569" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.81" cx="585" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.87" cx="601" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.58" cx="617" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.2" cx="633" cy="136" r="4" fill="#B6F4FC" />
          <circle opacity="0.3" cx="9" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.53" cx="25" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.75" cx="41" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.77" cx="57" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.24" cx="73" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.94" cx="89" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.14" cx="105" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.31" cx="121" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.57" cx="137" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.82" cx="153" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.71" cx="169" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.22" cx="185" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.38" cx="201" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.52" cx="217" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.26" cx="233" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.22" cx="249" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.39" cx="265" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.2" cx="281" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.19" cx="297" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.4" cx="313" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.87" cx="329" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.87" cx="345" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.41" cx="361" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.21" cx="377" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.69" cx="393" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.73" cx="409" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.47" cx="425" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.48" cx="441" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.53" cx="457" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.14" cx="473" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.22" cx="489" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.31" cx="505" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.87" cx="521" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.19" cx="537" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.47" cx="553" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.97" cx="569" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.84" cx="585" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.13" cx="601" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.82" cx="617" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.86" cx="633" cy="152" r="4" fill="#B6F4FC" />
          <circle opacity="0.15" cx="9" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.2" cx="25" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.66" cx="41" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.28" cx="57" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.82" cx="73" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.71" cx="89" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.53" cx="105" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.65" cx="121" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.15" cx="137" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.48" cx="153" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.11" cx="169" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.43" cx="185" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.61" cx="201" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.7" cx="217" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.72" cx="233" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.26" cx="249" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.3" cx="265" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.58" cx="281" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.41" cx="297" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.75" cx="313" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.55" cx="329" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.55" cx="345" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.98" cx="361" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.33" cx="377" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.83" cx="393" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.91" cx="409" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.81" cx="425" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.85" cx="441" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.57" cx="457" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.11" cx="473" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.45" cx="489" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.22" cx="505" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.6" cx="521" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.91" cx="537" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.97" cx="553" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.36" cx="569" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.41" cx="585" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.66" cx="601" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.35" cx="617" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.69" cx="633" cy="168" r="4" fill="#B6F4FC" />
          <circle opacity="0.4" cx="9" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.2" cx="25" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.6" cx="41" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.61" cx="57" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.59" cx="73" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.11" cx="89" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.16" cx="105" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.61" cx="121" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.89" cx="137" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.54" cx="153" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.89" cx="169" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.92" cx="185" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.32" cx="201" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.5" cx="217" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.98" cx="233" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.24" cx="249" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.18" cx="265" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.35" cx="281" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.67" cx="297" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.44" cx="313" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.61" cx="329" cy="184" r="4" fill="#B6F4FC" />
          <circle cx="345" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.28" cx="361" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.48" cx="377" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.55" cx="393" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.18" cx="409" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.4" cx="425" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.58" cx="441" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.1" cx="457" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.89" cx="473" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.79" cx="489" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.74" cx="505" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.62" cx="521" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.88" cx="537" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.22" cx="553" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.35" cx="569" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.29" cx="585" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.74" cx="601" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.33" cx="617" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.7" cx="633" cy="184" r="4" fill="#B6F4FC" />
          <circle opacity="0.35" cx="9" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.25" cx="25" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.37" cx="41" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.23" cx="57" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.46" cx="73" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.93" cx="89" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.39" cx="105" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.85" cx="121" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.45" cx="137" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.58" cx="153" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.7" cx="169" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.77" cx="185" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.52" cx="201" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.23" cx="217" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.42" cx="233" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.73" cx="249" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.24" cx="265" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.26" cx="281" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.99" cx="297" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.54" cx="313" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.16" cx="329" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.78" cx="345" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.19" cx="361" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.5" cx="377" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.88" cx="393" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.37" cx="409" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.82" cx="425" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.85" cx="441" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.28" cx="457" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.31" cx="473" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.57" cx="489" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.88" cx="505" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.61" cx="521" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.85" cx="537" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.44" cx="553" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.59" cx="569" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.23" cx="585" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.5" cx="601" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.54" cx="617" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.66" cx="633" cy="200" r="4" fill="#B6F4FC" />
          <circle opacity="0.81" cx="9" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.96" cx="25" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.4" cx="41" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.3" cx="57" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.88" cx="73" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.88" cx="89" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.67" cx="105" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.77" cx="121" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.48" cx="137" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.48" cx="153" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.95" cx="169" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.2" cx="185" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.6" cx="201" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.39" cx="217" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.66" cx="233" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.42" cx="249" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.79" cx="265" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.15" cx="281" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.29" cx="297" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.24" cx="313" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.56" cx="329" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.14" cx="345" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.43" cx="361" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.27" cx="377" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.87" cx="393" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.35" cx="409" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.43" cx="425" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.81" cx="441" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.4" cx="457" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.13" cx="473" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.25" cx="489" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.63" cx="505" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.92" cx="521" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.63" cx="537" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.93" cx="553" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.59" cx="569" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.26" cx="585" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.33" cx="601" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.85" cx="617" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.99" cx="633" cy="216" r="4" fill="#B6F4FC" />
          <circle opacity="0.55" cx="9" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.47" cx="25" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.36" cx="41" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.62" cx="57" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.54" cx="73" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.38" cx="89" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.8" cx="105" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.83" cx="121" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.23" cx="137" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.98" cx="153" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.9" cx="169" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.34" cx="185" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.71" cx="201" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.86" cx="217" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.58" cx="233" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.38" cx="249" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.86" cx="265" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.78" cx="281" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.69" cx="297" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.29" cx="313" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.71" cx="329" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.33" cx="345" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.38" cx="361" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.91" cx="377" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.72" cx="393" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.74" cx="409" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.63" cx="425" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.34" cx="441" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.65" cx="457" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.25" cx="473" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.93" cx="489" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.5" cx="505" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.6" cx="521" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.66" cx="537" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.59" cx="553" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.23" cx="569" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.53" cx="585" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.14" cx="601" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.42" cx="617" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.79" cx="633" cy="232" r="4" fill="#B6F4FC" />
          <circle opacity="0.23" cx="9" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.16" cx="25" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.11" cx="41" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.98" cx="57" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.25" cx="73" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.35" cx="89" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.37" cx="105" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.38" cx="121" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.9" cx="137" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.78" cx="153" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.75" cx="169" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.86" cx="185" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.53" cx="201" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.71" cx="217" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.54" cx="233" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.92" cx="249" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.52" cx="265" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.8" cx="281" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.26" cx="297" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.86" cx="313" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.5" cx="329" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.29" cx="345" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.52" cx="361" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.29" cx="377" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.32" cx="393" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.65" cx="409" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.86" cx="425" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.41" cx="441" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.18" cx="457" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.53" cx="473" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.63" cx="489" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.58" cx="505" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.22" cx="521" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.71" cx="537" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.45" cx="553" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.63" cx="569" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.93" cx="585" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.55" cx="601" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.39" cx="617" cy="248" r="4" fill="#B6F4FC" />
          <circle opacity="0.44" cx="633" cy="248" r="4" fill="#B6F4FC" />
        </g>
        <g filter="url(#filter0_ddd_905_5903)">
          <rect
            x="281.5"
            y="87.5"
            width="79"
            height="79"
            rx="13"
            fill="white"
            shapeRendering="crispEdges"
          />
          <rect
            x="281"
            y="87"
            width="80"
            height="80"
            rx="13.5"
            stroke="#C5F8FF"
            shapeRendering="crispEdges"
          />
          <g clipPath="url(#clip1_905_5903)">
            <path
              d="M348.5 116.688C348.5 118.585 346.96 120.125 345.062 120.125H340.972C341.38 121.47 341.625 122.811 341.625 123.562C341.625 125.46 340.085 127 338.188 127C336.29 127 334.75 125.46 334.75 123.562C334.75 122.811 334.993 121.47 335.403 120.125H331.312C329.415 120.125 327.875 118.585 327.875 116.688V112.597C329.22 113.005 330.561 113.25 331.312 113.25C333.21 113.25 334.75 111.71 334.75 109.812C334.75 107.915 333.21 106.375 331.312 106.375C330.561 106.375 329.22 106.618 327.875 107.028V102.938C327.875 101.04 329.415 99.5 331.312 99.5H339.333C344.396 99.5 348.5 103.604 348.5 108.667V116.688ZM301.028 129.292C300.62 127.946 300.375 126.606 300.375 125.854C300.375 123.957 301.915 122.417 303.812 122.417C305.71 122.417 307.25 123.957 307.25 125.854C307.25 126.606 307.007 127.946 306.597 129.292H314.125V112.104C314.125 110.207 312.585 108.667 310.688 108.667H302.667C297.604 108.667 293.5 112.771 293.5 117.833V129.292H301.028ZM335.896 133.875C337.793 133.875 339.333 135.415 339.333 137.312V145.333C339.333 150.396 335.229 154.5 330.167 154.5H318.708V133.875H326.236C325.829 135.22 325.583 136.561 325.583 137.312C325.583 139.21 327.123 140.75 329.021 140.75C330.918 140.75 332.458 139.21 332.458 137.312C332.458 136.561 332.215 135.22 331.805 133.875H335.896ZM314.125 154.5H302.667C297.604 154.5 293.5 150.396 293.5 145.333V133.875H314.125V141.403C312.78 140.995 311.439 140.75 310.688 140.75C308.79 140.75 307.25 142.29 307.25 144.188C307.25 146.085 308.79 147.625 310.688 147.625C311.439 147.625 312.78 147.382 314.125 146.972V154.5Z"
              fill="#48C8D9"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_ddd_905_5903"
          x="260.5"
          y="76.5"
          width="121"
          height="121"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_905_5903"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_905_5903"
            result="effect2_dropShadow_905_5903"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_905_5903"
            result="effect3_dropShadow_905_5903"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect3_dropShadow_905_5903"
            result="shape"
          />
        </filter>
        <radialGradient
          id="paint0_radial_905_5903"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(325.599 254) rotate(-90) scale(222.5 474.616)"
        >
          <stop stopColor="#D9D9D9" />
          <stop offset="1" stopColor="#737373" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_905_5903">
          <rect width="642" height="254" rx="13" fill="white" />
        </clipPath>
        <clipPath id="clip1_905_5903">
          <rect
            width="55"
            height="55"
            fill="white"
            transform="translate(293.5 99.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
